import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import FontAwesome from 'react-fontawesome'
import {getPointData, removeSnowflakeData} from '../../../services/applicationState'
import './styles.css'

export default class Nav extends Component {
    constructor(){
        super()
        this.state = {
            toggle: false,
            data: ''
        }
        this.toggleNav = this.toggleNav.bind(this)
        this.clear = this.clear.bind(this)
        this.closeMenu = this.closeMenu.bind(this)
    }

    toggleNav(){
        this.setState({
            toggle: !this.state.toggle
        });
    }

    clear() {
        if (getPointData()){
            removeSnowflakeData()
            window.location.replace(process.env.PUBLIC_URL + '/create' || '/create');
        }
        this.setState({
            toggle: !this.state.toggle
        });
    }

    closeMenu(){
        this.setState({
            toggle: !this.state.toggle
        });
    }

    render() {
        return (
            <div className={(this.state.toggle ? "nav active" : "nav")}>
                <FontAwesome name='bars' onClick={this.toggleNav}/>
                <nav>
                    <ul role="menubar">
                        <li role="menuitem" className='create-link'>
                            <Link to={'/create'} onClick={this.clear}>create a snowflake</Link>
                        </li>
                        <li role="menuitem">
                            <Link to={'/gallery'} onClick={this.closeMenu}>view gallery</Link>
                        </li>
                        <li role="menuitem">
                            <Link to={'/'} onClick={this.closeMenu}>view instructions</Link>
                        </li>
                        <li role="menuitem">
                            <a href='https://holiday.datausa.com/' target='_blank' onClick={this.closeMenu} rel="noopener noreferrer">holiday.datausa.com</a>
                        </li>
                    </ul>
                </nav>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/AppLayout/Navigation/index.js